module.exports = __webpack_public_path__ + "components/country-flag/static/cn-c3cdb262c243152869a9235368dc1b33.svg";